module.exports = __webpack_public_path__ + "static/media/ada-payment-icon.362daf0f.svg";